import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IInterventionGroup } from '../../../interventions/interfaces/IIntervention';
import {
  IInterventionsState,
  InterventionsMode,
} from '../../interfaces/states/IInterventionsState';

const initialState: IInterventionsState = {
  groups: [],
};

class InterventionsReducer extends ImmerReducer<IInterventionsState> {
  public setInterventions(groups: IInterventionGroup[]): void {
    this.draftState.groups = groups;
  }

  public setInterventionsMode(mode: InterventionsMode): void {
    this.draftState.mode = mode;
  }

  public resetState(): void {
    this.draftState = initialState;
  }

  public removeIntervention(interventionId: string): void {
    const groups: IInterventionGroup[] = [...this.draftState.groups];
    let groupIndex = 0;
    let interventionIndex = 0;
    let foundIndex = false;
    for (let i = 0; i < groups.length; i++) {
      const index = groups[i].interventions.findIndex(x => x.interventionId === interventionId);
      if (index !== -1) {
        groupIndex = i;
        interventionIndex = index;
        foundIndex = true;
        break;
      }
    }
    if (foundIndex) {
      if (groups[groupIndex].interventions.length > 1) {
        groups[groupIndex].interventions.splice(interventionIndex, 1);
        this.draftState.groups[groupIndex].interventions = groups[groupIndex].interventions;
      } else {
        groups.splice(groupIndex, 1);
        this.draftState.groups = groups;
      }
    }
  }
}

export const InterventionsActions = createActionCreators(InterventionsReducer);
export const InterventionsReducerFunction = createReducerFunction(
  InterventionsReducer,
  initialState,
);
